import type { Title as Banner } from '../../../amplienceTypes/schemas/exported/banner-schema';

import type {
  Attributes,
  RowAttributes,
} from '~/amplienceTypes/partials/exported/element-attributes-schema';
import type {
  Column,
  ContentSection,
} from '~/amplienceTypes/schemas/exported/localized-section-schema';
import type { SectionText } from '~/amplienceTypes/schemas/exported/section-text-schema';

// TODO: FS-3437 - PLP Moodbanners remove code for suppressing inline styling
const classNameRegEx =
  /-\d{2}Q|imageless|ATFL|buttonSmall|TitleSize|\d{2}SS|buttonPill|genderSplit|col--flowbox-head/;

const attributeNameRegEx = /data-title-size|data-subtitle-size|data-body-size/;

// eslint-disable-next-line no-undef
export const removeClassNamesFromAttributes = (
  _attributes: (Attributes & RowAttributes) | undefined
) => {
  const attributes = _attributes;

  if (attributes?.classNames?.length) {
    attributes.classNames = attributes.classNames.filter(
      className => !classNameRegEx.test(className)
    );
  }

  if (attributes?.dataAttributes?.length) {
    attributes.dataAttributes = attributes.dataAttributes.filter(
      ({ name }) => name && !attributeNameRegEx.test(name)
    );
  }

  return attributes;
};

/**
 * TODO: FS-3437 - PLP Moodbanners remove code for suppressing inline styling
 */
// eslint-disable-next-line no-undef
export const removeLegacyModifierClassNames = (_content: Banner | ContentSection) => {
  const content = _content;

  if (content.attributes) {
    Object.assign(content.attributes, removeClassNamesFromAttributes(content?.attributes));
  }

  const { contentBlock } = content as Banner;

  if (contentBlock?.attributes) {
    Object.assign(contentBlock.attributes, removeClassNamesFromAttributes(contentBlock.attributes));
  }

  const { column } = content as ContentSection;

  if (column) {
    column.forEach(({ attributes, content }: Column) => {
      if (attributes) {
        Object.assign(attributes, removeClassNamesFromAttributes(attributes));
      }

      if (content?.length) {
        content.forEach(({ attributes }: SectionText) => {
          if (attributes) {
            Object.assign(attributes, removeClassNamesFromAttributes(attributes));
          }
        });
      }
    });
  }

  return content;
};
